import React from "react";
import "./Hero.sass";

export default function Hero() {
  return (
    <div className="hero">
      <div
        className="hero-bg"
        style={{
          background: "url('/images/header-hero.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div
        className="hero-bottom"
        style={{
          background:
            "linear-gradient(0.17deg, rgba(0, 0, 0, 0.84) 1.74%, rgba(22, 54, 110, 0.84) 98.12%), url('/images/header-hero-top-banner.png')",
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundSize: "cover, cover",
          backgroundPosition: "center, center",
        }}
      >
        <div className="hero-bottom-container">
          <div className="hero-frog">
            <img src="/images/gif1.png" alt="hero" />
          </div>
          <div className="hero-text">
            <div className="hero-title">
              <div className="hero-title-image">
                <img src="/images/logo-frog.png" alt="logo meme" />
              </div>
              <h2>Social Club</h2>
            </div>
            <div className="hero-frog-small">
              <img src="/images/gif1.png" alt="hero" />
            </div>
            <div className="hero-description">
              <p>
                OnlyFrens is a Comfy Collection of 1,777 Frens. The Collection
                Includes Over 175 Unique Hand-Crafted Attributes. Among these
                are 1:1 Fully Animated Pixel Gifs (FrogGods), Semi-Animated
                Characters (DemiGods), and a Ranked collection of 1,660 Frens.
              </p>
              <p>
                Our Mission is to tear down the Ridiculous barriers to entry the
                NFT Space has created! Using our Freemium model, we will be
                giving NFTs away for free to the Enlightened.{" "}
              </p>
              <p>
                We seek REAL social change through incentivized participation in
                our social game.
              </p>
              <p>
                At the heart of the Collection is an Economy sustained through
                Uncle Elon’s Dream Machine. This consists of two mechanisms: the
                frENGINE and the degENGINE{" "}
              </p>
            </div>
            <div className="hero-cta">
              <a href="https://discord.gg/onlyfrens">
                <button>JOIN NOW</button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-holder"></div>
    </div>
  );
}
